import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const articles = [
  {
    category: 'Cold Chain',
    title: 'Why India\'s Frozen Food Market Is Poised for a 10x Decade',
    date: 'June 18, 2026',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=Cold%20storage%20warehouse%20interior%20with%20frosted%20racking%20and%20blue%20industrial%20lighting%2C%20clean%20minimal%20infrastructure%20photography%2C%20professional%20corporate%20aesthetic%2C%20no%20people%2C%20cool%20ambient%20tones&width=800&height=500&seq=freshhlock-blog-01&orientation=landscape',
    href: '/company',
  },
  {
    category: 'Food Safety',
    title: 'HACCP, FSSAI, and the New Standard for Frozen Food Traceability',
    date: 'June 10, 2026',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=Professional%20food%20safety%20laboratory%20with%20testing%20equipment%20and%20stainless%20steel%20surfaces%2C%20clean%20minimal%20industrial%20photography%2C%20corporate%20style%2C%20cool%20ambient%20lighting%2C%20no%20people&width=800&height=500&seq=freshhlock-blog-02&orientation=landscape',
    href: '/company',
  },
  {
    category: 'Industry',
    title: 'From Catch to Kitchen: How Technology Is Rewiring India\'s Seafood Supply Chain',
    date: 'May 28, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=Modern%20seafood%20processing%20facility%20with%20industrial%20IQF%20freezing%20conveyor%20lines%20and%20packaged%20cartons%2C%20clean%20professional%20photography%2C%20cool%20steel%20and%20white%20tone%20aesthetic%2C%20no%20people&width=800&height=500&seq=freshhlock-blog-03&orientation=landscape',
    href: '/company',
  },
];

export default function InsightsSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 warm-sand-bg">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
              Insights
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700">
              From the Freshhlock Blog
            </h2>
          </div>
          <Link
            to="/company"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            View all articles
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.title}
              to={article.href}
              className="group bg-card-50 border border-card-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-pointer card-animate"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">{article.category}</span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading font-bold text-primary-700 text-base mb-3 group-hover:text-accent-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}